// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b080de3","455":"683390b7","488":"39f54ca5","977":"fa45462c"}[chunkId] + ".chunk.js";
};